import {
    IAnalisesDeCreditoBody,
    IListarAnaliseDeCredito,
    IListarAnalistasDeCredito,
} from "../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function AnaliseDeCreditoServices<
    TResponseType extends IListarAnaliseDeCredito | Blob
>(pagina: number, responseBody: IAnalisesDeCreditoBody, exportExcel?: boolean) {
    return Service(
        Axios.post<TResponseType>(
            `/vendas/analisedecredito/listaranalisedecreditopendente?PAGINA=${pagina}&exportExcel=${exportExcel}`,
            responseBody,
            { responseType: exportExcel ? "blob" : "json" }
        )
    );
}

export async function ListarAnalistasDeCreditoServices() {
    return Service(
        Axios.get<Array<IListarAnalistasDeCredito>>(
            `/vendas/usuariosvendas/listaranalistascredito`
        )
    );
}


